/**
 * Company Search — relationship band (sealed element b, DG-DISPLAY-1).
 *
 * Four sanitized facts: CLIENT HISTORY (Yes/No from existing_client — the same
 * engagement-record-backed field the Engagements card counts, so the two stay
 * consistent), engagement count, case-study yes/no, and the max Value Tier
 * (Tier 1/2/3 only). Every value is backed by get_company_profile.
 *
 * Active/Dormant is deliberately NOT shown on the band: engagement currency is
 * not reliably known here, so an Active/Dormant claim would be the same false
 * behavioral claim the "Engagements" title rename removed. The
 * relationship_status plumbing stays intact upstream (types/api/logic) — this
 * is a display-only change.
 */

function Tile({ label, value }: { label: string; value: string }): JSX.Element {
  return (
    <div className="sxco-relband-tile">
      <p className="sxco-relband-lbl">{label}</p>
      <p className="sxco-relband-val">{value}</p>
    </div>
  );
}

export function RelationshipBand({
  existingClient,
  engagementCount,
  hasCaseStudy,
  valueTier,
}: {
  existingClient: boolean;
  engagementCount: number;
  hasCaseStudy: boolean;
  valueTier: string | null;
}): JSX.Element {
  return (
    <div className="sxco-relband">
      <Tile label="Client history" value={existingClient ? "Yes" : "No"} />
      <Tile label="Engagements" value={String(engagementCount)} />
      <Tile label="Case studies" value={hasCaseStudy ? "Yes" : "No"} />
      <Tile label="Value tier" value={valueTier ?? "—"} />
    </div>
  );
}
